/* ZINKE - Cookie-Banner: Tipp daneben stimmt zu, Kaufweg bleibt frei
   (22.09.2026 Theme 6.5 - geaendert 23.09.2026 Theme 7.3 auf Pascals Anweisung
    - erweitert 25.09.2026 Theme 7.8: Entscheidung wird lokal gemerkt)
   ------------------------------------------------------------------------------------
   Anlass 22.09.: Microsoft Clarity zeigte tote Klicks auf "In den Warenkorb".
   Gemessen am Handy (390x844): der Shopify-Banner stand von 625 bis 840 px,
   die Kaufleiste von 786 bis 834 px - der Banner lag also genau auf dem Knopf.

   Anlass 25.09.: Pascal meldet, dass der Banner nach Produktseite + Zurueck
   wieder auftaucht. Ursache: bis 7.7 wurde der Banner nur mit
   el.style.display = 'none' ausgeblendet. Das gilt nur fuer die eine Seite.
   Ob er auf der naechsten Seite wiederkommt, entscheidet allein Shopifys
   Consent-Cookie. setTrackingConsent braucht dafuer rund 200 ms (gemessen
   25.09. mit Playwright gegen die Live-Seite) - wer gleichzeitig auf einen
   Produktlink tippt, navigiert schneller weg, als der Aufruf fertig wird.
   Die Einwilligung geht verloren, der Banner kommt zurueck.

   Ab 7.8 wird die Entscheidung zusaetzlich lokal gemerkt:
   - 'tipp'  = weggetippt. Auf jeder Folgeseite wird der Banner sofort
               ausgeblendet UND die Einwilligung erneut gesetzt, bis
               Shopifys eigenes Cookie steht.
   - 'knopf' = im Banner auf Akzeptieren oder Ablehnen getippt. Shopify
               speichert das selbst; der Merker haelt den Banner nur weg,
               falls das Speichern verloren geht.
   Der Knopf "Cookies" unten links LOESCHT den Merker und holt den Banner
   zurueck - der Widerruf bleibt damit einen Tipp entfernt.

   Drei Dinge passieren hier:
   1. Der Banner wird ueber die unterste feste Leiste gehoben (Kaufleiste,
      Warenkorbleiste). Gemessen wird die Leiste, nicht geraten.
   2. Ein Tipp neben den Banner blendet ihn aus. Der Tipp wird NICHT abgefangen -
      wer auf "In den Warenkorb" tippt, legt den Artikel auch wirklich hinein.
   3. Dabei wird die Einwilligung GESETZT (analytics, marketing, preferences,
      sale_of_data) ueber Shopify.customerPrivacy.setTrackingConsent.
      GEAENDERT am 23.09.2026 auf ausdrueckliche Anweisung von Pascal. */

(function () {
  'use strict';

  var ID = 'shopify-pc__banner';
  var SCHONZEIT = 500; // ms nach dem Einblenden, damit ein laufender Tipp den Banner nicht sofort schliesst
  var MERKER = 'zinke-cookie-entschieden';
  var MERKER_TAGE = 180;
  var sichtbarSeit = 0;
  var knopf = null;

  function banner() {
    return document.getElementById(ID);
  }

  function offen(el) {
    if (!el) return false;
    var cs = window.getComputedStyle(el);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && el.offsetHeight > 0;
  }

  /* ---- Merker: hat sich der Besucher schon entschieden? ------------------
     Liegt im localStorage, gilt MERKER_TAGE lang und ueberlebt damit jeden
     Seitenwechsel, Zurueck-Knopf und Neustart des Browsers. */
  function merkerLesen() {
    try {
      var roh = window.localStorage.getItem(MERKER);
      if (!roh) return null;
      var teile = roh.split('|');
      var zeit = parseInt(teile[1], 10);
      if (!zeit || (Date.now() - zeit) > MERKER_TAGE * 86400000) return null;
      return teile[0] === 'tipp' ? 'tipp' : 'knopf';
    } catch (e) { return null; }
  }

  function merkerSchreiben(art) {
    try { window.localStorage.setItem(MERKER, art + '|' + Date.now()); } catch (e) {}
  }

  function merkerLoeschen() {
    try { window.localStorage.removeItem(MERKER); } catch (e) {}
  }

  /* Einwilligung setzen. Die Consent-API liegt unter Shopify.customerPrivacy;
     ist sie noch nicht geladen, wird sie ueber Shopify.loadFeatures nachgezogen. */
  function einwilligen() {
    var werte = { analytics: true, marketing: true, preferences: true, sale_of_data: true };

    function setzen(api) {
      if (!api || typeof api.setTrackingConsent !== 'function') return;
      try { api.setTrackingConsent(werte, function () {}); } catch (e) {}
    }

    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.setTrackingConsent === 'function') {
        setzen(cp);
        return;
      }
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (fehler) {
          if (fehler) return;
          setzen(window.Shopify && window.Shopify.customerPrivacy);
        });
      }
    } catch (e) {}
  }

  /* Steht Shopifys eigene Einwilligung schon? Dann muss nichts nachgezogen werden. */
  function shopifyHatConsent() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.currentVisitorConsent !== 'function') return false;
      var c = cp.currentVisitorConsent();
      return !!(c && (c.analytics === 'yes' || c.marketing === 'yes' || c.analytics === 'no' || c.marketing === 'no'));
    } catch (e) { return false; }
  }

  /* Hoehe der untersten festen Leiste messen (Kaufleiste, Warenkorbleiste, App-Leisten).
     Zaehlt nur, was wirklich am unteren Rand klebt und Tipps annimmt. */
  function leistenhoehe() {
    var hoehe = 0;
    var alle = document.querySelectorAll('div, section, form, aside, nav');
    for (var i = 0; i < alle.length; i++) {
      var el = alle[i];
      if (el.id === ID || el.closest('#' + ID)) continue;
      var cs = window.getComputedStyle(el);
      if (cs.position !== 'fixed' && cs.position !== 'sticky') continue;
      if (cs.display === 'none' || cs.visibility === 'hidden' || cs.pointerEvents === 'none') continue;
      var r = el.getBoundingClientRect();
      if (r.height === 0 || r.width < window.innerWidth * 0.6) continue;
      if (Math.abs(r.bottom - window.innerHeight) > 4) continue; // klebt nicht unten
      if (r.height > window.innerHeight * 0.35) continue;         // das ist keine Leiste mehr
      if (r.height > hoehe) hoehe = r.height;
    }
    return Math.round(hoehe);
  }

  function positionieren() {
    var h = leistenhoehe();
    if (h) {
      document.documentElement.style.setProperty('--zinke-banner-unten', (h + 8) + 'px');
    } else {
      document.documentElement.style.removeProperty('--zinke-banner-unten');
    }
    if (knopf) knopf.style.bottom = (h ? h + 10 : 14) + 'px';
  }

  function zurueckholen() {
    merkerLoeschen(); // Widerruf: der Banner darf wieder erscheinen
    var el = banner();
    if (window.privacyBanner && typeof window.privacyBanner.showBanner === 'function') {
      if (el) el.style.display = '';
      try { window.privacyBanner.showBanner(); } catch (e) {}
    } else if (el) {
      el.style.display = '';
    }
    sichtbarSeit = Date.now();
    if (knopf) knopf.hidden = true;
    positionieren();
  }

  function knopfBauen() {
    if (knopf) { knopf.hidden = false; positionieren(); return; }
    knopf = document.createElement('button');
    knopf.type = 'button';
    knopf.className = 'zinke-cookie-zurueck';
    var LABEL = {
      en: 'Open cookie settings',
      nl: 'Cookie-instellingen openen',
      fr: 'Ouvrir les paramètres des cookies',
      es: 'Abrir la configuración de cookies',
      da: 'Åbn cookieindstillinger',
      sv: 'Öppna cookie-inställningar',
      fi: 'Avaa evästeasetukset',
      pl: 'Otwórz ustawienia plików cookie',
      de: 'Cookie-Einstellungen öffnen'
    };
    var sprache = (document.documentElement.lang || 'de').slice(0, 2).toLowerCase();
    knopf.setAttribute('aria-label', LABEL[sprache] || LABEL.de);
    knopf.textContent = 'Cookies';
    knopf.addEventListener('click', function (e) {
      e.stopPropagation();
      zurueckholen();
    });
    document.body.appendChild(knopf);
    positionieren();
  }

  function schliessen() {
    var el = banner();
    if (!offen(el)) return;
    if (Date.now() - sichtbarSeit < SCHONZEIT) return;
    merkerSchreiben('tipp'); // zuerst merken - das ueberlebt auch eine sofortige Navigation
    einwilligen();
    el.style.display = 'none';
    knopfBauen();
  }

  /* Tipp irgendwo ausserhalb des Banners: Einwilligung gesetzt, Banner weg,
     Tipp laeuft normal weiter. Kein preventDefault, kein stopPropagation -
     der Warenkorb-Knopf loest aus. */
  function beiTipp(ereignis) {
    var el = banner();
    if (!offen(el)) return;
    var ziel = ereignis.target;
    if (!ziel || ziel.nodeType !== 1) {
      ziel = ziel && ziel.parentElement ? ziel.parentElement : null;
    }
    if (ziel && typeof ziel.closest === 'function' && ziel.closest('#' + ID)) return; // im Banner: Shopify macht seins
    if (ziel === knopf || (ziel && typeof ziel.closest === 'function' && ziel.closest('.zinke-cookie-zurueck'))) return;
    schliessen();
  }

  document.addEventListener('pointerdown', beiTipp, true);
  document.addEventListener('touchstart', beiTipp, { capture: true, passive: true });

  /* Tipp AUF einen Knopf im Banner (Akzeptieren, Ablehnen, Einstellungen):
     Shopify speichert das selbst. Wir merken uns nur, dass eine Entscheidung
     gefallen ist - falls Shopifys Speichern unterwegs verloren geht. */
  document.addEventListener('pointerdown', function (ereignis) {
    var ziel = ereignis.target;
    if (!ziel || ziel.nodeType !== 1 || typeof ziel.closest !== 'function') return;
    if (!ziel.closest('#' + ID)) return;
    if (!ziel.closest('button')) return;
    if (ziel.closest('.shopify-pc__banner__btn-manage-prefs')) return; // oeffnet nur die Auswahl
    merkerSchreiben('knopf');
  }, true);

  /* Banner beobachten: wann taucht er auf, wo steht er.
     Hat sich der Besucher schon entschieden, wird der Banner sofort
     ausgeblendet - ohne Schonzeit, denn die Entscheidung liegt schon vor. */
  function beobachten() {
    var el = banner();
    if (offen(el)) {
      var art = merkerLesen();
      if (art) {
        if (art === 'tipp' && !shopifyHatConsent()) einwilligen();
        el.style.display = 'none';
        knopfBauen();
        return;
      }
      if (!sichtbarSeit) sichtbarSeit = Date.now();
      positionieren();
    } else if (!el) {
      sichtbarSeit = 0;
    }
  }

  var beobachter = new MutationObserver(beobachten);
  beobachter.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });

  window.addEventListener('scroll', function () {
    if (offen(banner())) positionieren();
  }, { passive: true });
  window.addEventListener('resize', function () {
    if (offen(banner())) positionieren();
  });

  /* Zurueck-Knopf: kommt die Seite aus dem Vor-Zurueck-Speicher des Browsers,
     laeuft dieses Skript nicht neu. pageshow deckt genau diesen Fall ab. */
  window.addEventListener('pageshow', function () {
    if (merkerLesen()) knopfBauen();
    beobachten();
  });

  /* Wer sich schon entschieden hat, soll den Widerrufs-Knopf sehen,
     auch wenn der Banner gar nicht erst auftaucht. */
  if (merkerLesen()) {
    if (document.body) knopfBauen();
    else document.addEventListener('DOMContentLoaded', knopfBauen);
  }

  beobachten();
})();
